import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { GlobalConstants } from 'src/app/pages/common/global-variables';

@Component({
  selector: 'app-penny-drop-modal',
  templateUrl: './penny-drop-modal.component.html',
  styleUrls: ['./penny-drop-modal.component.scss']
})
export class PennyDropModalComponent implements OnInit {

  constructor(
    public GlobalConstants: GlobalConstants,
    public _bsModalRef: BsModalRef,
    private router: Router
  ) { }

  ngOnInit(): void {
  }

  public handleClose() {
    this._bsModalRef.hide();
    this.router.navigate([], {
      queryParams: {},
      queryParamsHandling: 'merge'
    });
  }

}
